export default {
  isLoading: false,
  divisions: [],
  division: {
    id: '',
    name: '',
  },
  userId: '',
};
